import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { useUser, useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';

import URLHelpers from '../../shared/url_helpers';
import USD from '../../../../images/sell-flow/sell-your-gear.svg';
import Tags from '../../../../images/sell-flow/add-to-my-collection.svg';

export default function HomepageSellVisibilityV1() {

  const backgroundImage = 'https://reverb-res.cloudinary.com/image/upload/v1641407740/fxltmj3h1glcpbrdejdn';
  const COMPONENT_NAME = 'HomepageSellVisibilityV1';
  const user = useUser();

  useViewTracking({
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.HOMEPAGE_SELL_VISIBILITY_V1,
    ]),
  }, true);

  if (!useExpEnabled(experiments.HOMEPAGE_SELL_VISIBILITY_V1)) {
    return null;
  }

  return (
    <div className="homepage-container__component-wrapper">
      <div className="homepage-sell-visibility">
        <div className="homepage-sell-visibility__card" style={{ backgroundImage: `url("${backgroundImage}")` }}>
          <div className="homepage-sell-visibility__icon-container">
            <img
              src={Tags}
              alt={I18n.t('discovery.homepage.sellVisibilityV1.tagsAlt')}
              className="homepage-sell-visibility__icon"
            />
          </div>
          <div className="homepage-sell-visibility__card-content">
            <h2 className="homepage-sell-visibility__card-title">
              {I18n.t('discovery.homepage.sellVisibilityV1.buyTitle')}
            </h2>
            <p>{I18n.t('discovery.homepage.sellVisibilityV1.keepTrackOf')}</p>
            <CoreLink
              to={URLHelpers.gearCollectionsPath}
              className="homepage-sell-visibility__button"
              clickEvent={{
                componentName: COMPONENT_NAME,
                entityId: URLHelpers.gearCollectionsPath,
                entityType: 'url',
                eventName: MParticleEventName.ClickedComponent,
              }}
            >
              {I18n.t('discovery.homepage.sellVisibilityV1.buyButton')}
            </CoreLink>
          </div>
        </div>
        <div className="homepage-sell-visibility__card" style={{ backgroundImage: `url("${backgroundImage}")` }}>
          <div className="homepage-sell-visibility__icon-container">
            <img
              src={USD}
              alt={I18n.t('discovery.homepage.sellVisibilityV1.usdAlt')}
              className="homepage-sell-visibility__icon"
            />
          </div>
          <div className="homepage-sell-visibility__card-content">
            <h2 className="homepage-sell-visibility__card-title">
              {I18n.t('discovery.homepage.sellVisibilityV1.sellTitle')}
            </h2>
            <p>{I18n.t('discovery.homepage.sellVisibilityV1.listYourGear')}</p>
            <CoreLink
              to={URLHelpers.sellFormSearchPath()}
              className="homepage-sell-visibility__button"
              clickEvent={{
                componentName: COMPONENT_NAME,
                entityId: URLHelpers.sellFormSearchPath(),
                entityType: 'url',
                eventName: MParticleEventName.ClickedComponent,
              }}
            >
              {I18n.t('discovery.homepage.sellVisibilityV1.sellButton')}
            </CoreLink>
          </div>
        </div>
      </div>
    </div>
  );
}
